import styled from 'styled-components'
import { colors } from '../../theme'

export const ButtonSave = styled.button`
  margin-top: 10px;
  cursor: pointer;
  background-color: ${colors.accentBg};
  color: ${colors.white};
  border: none;
  width: 240px;
  height: 40px;
  border-radius: 12px;
`

export const ButtonClosed = styled.button`
  background: ${colors.surface};
  border: none;
  margin-top: -70px;
  margin-right: -25px;
  cursor: pointer;
`

export const ButtonClosedOption = styled.button`
  background: ${colors.grey200};
  border: none;
  margin-top: 6px;
  cursor: pointer;
`

export const OptionActive = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`

export const Option = styled.div`
  height: 30px;
  padding: 0px 5px 0px 5px;
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${colors.grey900};
  font-weight: 500;
  font-size: 12px;
  line-height: 2em;
  text-align: left;
  margin-left: 15px;
  margin-top: 5px;
  border-radius: 4px;
  background-color: ${colors.grey200};
  cursor: pointer;
`

export const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100px;
  margin-top: -20px;
`

export const Componentes = styled.div`
  position: relative;
  padding: 5px 30px 5px 20px;
  width: 100%;
  text-align: left;

  label {
    position: absolute;
    top: -4px;
    left: 35px;
    background: ${colors.surface};
    color: ${colors.grey500};
    padding: 0 3px;
    font-size: 12px;
  }

  input {
    width: 100%;
    height: 23px;
    border: 1px solid ${colors.grey300};
    border-radius: 12px;
    font-size: 14px;
    padding: 20px 20px 20px 20px;
    margin-bottom: 5px;
  }
  input:focus {
    outline: none;
  }

  select {
    width: 320px;
    height: 23px;
    border: 1px solid ${colors.grey300};
    border-radius: 12px;
    font-size: 14px;
    padding: 20px 20px 20px 20px;
  }
  option {
    font-size: 14px;
    font-weight: 600;
  }

  span {
    font-size: 12px;
    color: ${colors.errorText};
  }
`

export const ContainerModalSend = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-top: 8%;
  background-color: ${colors.overlay};
  display: block;
  z-index: 2001;
`

export const SendStyle = styled.div`
  width: 500px;
  background-color: ${colors.surface};
  border-radius: 10px;
  padding: 40px;
  margin: 0 auto;
  text-align: center;

  h1 {
    color: ${colors.grey900};
    font-weight: 600;
    font-size: 22px;
    line-height: 1.2em;
    text-align: left;
    margin-left: 20px;
  }
`

export const ListStyle = styled.div`
  background-color: ${colors.surface};
  border-radius: 10px;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 30px;
`
